export interface ConnectionTypeMeta {
  icon: string;
  badgeClass: string;
}

export const CONNECTION_TYPE_META: Record<string, ConnectionTypeMeta> = {
  ftp: { icon: '📁 ftp', badgeClass: 'bg-blue-900 text-blue-200' },
  sftp: { icon: '🔐 sftp', badgeClass: 'bg-yellow-800 text-yellow-100' },
  postgresql: { icon: '🐘 postgresql', badgeClass: 'bg-indigo-900 text-indigo-200' },
  rest: { icon: '🌐 rest', badgeClass: 'bg-green-900 text-green-200' },
  restlet: { icon: '🧩 restlet', badgeClass: 'bg-purple-900 text-purple-200' },
};
